/** Mirror backend has_basic_access for UI gating. */
export function isPlatformAdmin(user) {
  if (!user) return false;
  return !!(user.is_superuser || user.subscription_tier === 'admin');
}

export function hasBasicAccess(user) {
  if (!user) return false;
  if (isPlatformAdmin(user) || user.lifetime_free) return true;
  if (
    user.subscription_status === 'trial'
    && user.trial_end_at
    && new Date(user.trial_end_at) > new Date()
  ) {
    return true;
  }
  return (
    ['active', 'past_due', 'trial'].includes(user.subscription_status)
    && ['basic', 'pro'].includes(user.data_access_level || 'none')
  );
}

export function dueDiligenceHint(user) {
  if (!user) return 'Sign in and subscribe to Basic or Pro to run property due diligence.';
  if (!hasBasicAccess(user)) return 'Available on Basic or Pro plans.';
  return 'Analyse an off-market or pre-listing address.';
}

export function premiumFeatureHint(user) {
  if (!user) return 'Sign in and subscribe to Basic or Pro to unlock this feature.';
  if (!hasBasicAccess(user)) return 'Available on Basic or Pro plans.';
  return null;
}

export function premiumUpgradeHref(user) {
  return user ? '/choose-plan' : '/login';
}

export function premiumUpgradeLabel(user) {
  return user ? 'View plans' : 'Sign in';
}
